import React, { useState, useEffect } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import RpRowHtml from "@/components/rowHtml/RpRowHtml";
import type { ResourceFaq } from "../types";

const RowHtml = RpRowHtml as React.ComponentType<{
  as?: React.ElementType;
  className?: string;
  component?: string;
  html?: string;
}>;

interface FAQSectionProps {
  faq?: ResourceFaq[];
}

export default function FAQSection({ faq = [] }: FAQSectionProps) {
  const [expandedAccordion, setExpandedAccordion] = useState<number | null>(
    null
  );

  const handleChange =
    (panel: number) => (_event: React.SyntheticEvent, isExpanded: boolean) => {
      setExpandedAccordion(isExpanded ? panel : null);
    };

  useEffect(() => {
    if (faq.length) {
      setExpandedAccordion(faq[0].id);
    }
  }, [faq]);

  return (
    <div className="faq-section w-100 my-4">
      {faq &&
        faq.map((data) => (
          <Accordion
            key={data.id}
            className="ac-faq-card"
            expanded={expandedAccordion === data.id}
            onChange={handleChange(data.id)}
            TransitionProps={{ unmountOnExit: true, mountOnEnter: true }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon />}>
              <Typography
                className="mb-0 faq-question"
                component="h5"
                variant="body1"
              >
                {data.question}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <RowHtml
                className="faq-answer"
                as={Typography}
                html={data.answer}
                component="div"
              />
            </AccordionDetails>
          </Accordion>
        ))}
    </div>
  );
}
